import { FirebaseData } from "../../General/FirebaseData";

export class CompanyActionValidatorData extends FirebaseData {

  actions: {
    [actionID: string]: {
      allowedGroups: string[]
    }
  } = {}

  setup(data: any) {
    super.setup(data);

    this.actions = {}
    if (typeof data.actions === "object") {
      for (const actionID of Object.keys(data.actions)) {
        this.actions[actionID] = {
          allowedGroups: Array.isArray(data.actions[actionID].allowedGroups) ? data.actions[actionID].allowedGroups : []
        }
      }
    }
  }
}
